export default {
  app: {
    privacy: {
      policy: 'dasar privasi',
      expansive: 'Dengan menggunakan Expansive, anda bersetuju dengan {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sesi tamat',
    sessionExpiredDescription:
      'Sesi anda telah tamat. Sila log masuk semula untuk terus menggunakan aplikasi.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Pilih bahasa',
      chooseLanguageDescription:
        'Pilih bahasa pilihan anda untuk aplikasi. Ini akan menukar bahasa antara muka dan kandungan.',
    },
    userSelection: {
      cancel: 'Batal',
      createNewUser: 'Nama mereka tiada dalam senarai',
      newUser: 'Pengguna baharu',
      selectAnExistingUser: 'Pilih pengguna sedia ada',
      selectUserHint: 'Pilih pengguna sedia ada atau cipta pengguna baharu untuk meneruskan.',
      startTypingToSearch: 'Mula menaip...',
    },
    verification: {
      codeVerification: {
        continue: 'Teruskan',
        header: 'Masukkan kod akses tapak',
        invalidCode: 'Kod tidak sah, sila cuba lagi.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Teruskan tanpa pengesahan lokasi',
        enterSiteAccessCode: 'Masukkan kod akses tapak',
        locationNotEnabledOrAvailable: 'Mengapa saya melihat ini?',
        notAvailable: {
          description: 'Lokasi GPS tidak disokong pada peranti ini.',
          header: 'Lokasi tidak disokong',
        },
        notEnabled: {
          description: 'Perkhidmatan lokasi tidak diaktifkan atau kebenaran tidak diberikan.',
          header: 'Lokasi tidak diaktifkan',
        },
        notVerified: {
          description: 'GPS menunjukkan anda tidak berada di tapak.',
          header: 'Lokasi tidak disahkan',
        },
        tryAgain: 'Cuba lagi',
        unavailable: {
          description: 'Kami tidak dapat mengesahkan lokasi GPS anda.',
          header: 'Lokasi tidak tersedia',
        },
        unknown: {
          description: 'Kami tidak dapat menentukan lokasi anda.',
          header: 'Lokasi tidak diketahui',
        },
        verified: {
          description: 'GPS menunjukkan anda berada di tapak.',
          header: 'Lokasi disahkan',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Tiada aset dijumpai',
        emptyDescription: 'Tiada aset dikaitkan dengan pesanan kerja ini.',
        warrantyParts: 'Jaminan alat ganti tamat',
        serialNumber: 'Nombor siri',
        none: '<tiada>',
      },
      updates: {
        emptyTitle: 'Tiada kemas kini dijumpai',
        emptyDescription: 'Tiada kemas kini untuk pesanan kerja ini.',
        unknownUser: 'Pengguna tidak diketahui',
        none: 'Tiada',
        addComment: {
          buttonLabel: 'Tambah komen',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Bahaya',
          no: 'Tidak',
          yes: 'Ya',
        },
      },
    },
    attachmentsList: {
      attachments: 'Lampiran',
      documents: 'Dokumen',
      siteDocuments: 'Dokumen Tapak',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Bahaya',
        induction: 'Induksi',
        safeToProceed: 'Selamat untuk diteruskan',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Tarikh tamat tempoh',
        activeSessions: 'Sesi aktif',
        activeSessionsDescription:
          'Anda sudah mendaftar masuk ke pesanan kerja berikut. Anda mesti daftar keluar dari pesanan kerja ini sebelum mendaftar masuk ke pesanan kerja baharu.',
        resumeSession: 'Sambung',
        startTime: 'Bermula pada',
        unexpectedErrorTitle: 'Ralat tidak dijangka',
        unexpectedErrorMessage:
          'Ralat tidak dijangka berlaku semasa cuba mencipta sesi anda. Sila cuba lagi kemudian.',
        engineerNotFound: 'Jurutera tidak dijumpai',
        engineerNotFoundDescription:
          'Jurutera yang anda cuba daftar masuk tidak dijumpai dalam sistem. Sila hubungi pentadbir anda.',
      },
      verification: {
        code: {
          description:
            'Untuk daftar masuk, sila dapatkan kod 4 digit daripada pengurus tapak atau orang yang ditetapkan.',
        },
        geo: {
          continue: 'Teruskan',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Sila dapatkan kod akses daripada pengurus tapak atau pihak yang dilantik untuk melengkapkan lawatan anda.',
            checkOut: 'Daftar keluar',
            completeBeforeLeaving: 'Sila lengkapkan borang berikut sebelum meninggalkan tapak.',
            continue: 'Teruskan',
            noResolutionSelected: 'Sila pilih resolusi sebelum meneruskan.',
            quoteRequired: {
              hint: 'Lawatan selesai, sebut harga akan diberikan',
              label: 'Sebut harga diperlukan',
            },
            returnVisitRequired: {
              hint: 'Kami akan kembali untuk melengkapkan',
              label: 'Lawatan semula diperlukan',
            },
            serviceCompleted: {
              hint: 'Tiada tindakan lanjut diperlukan',
              label: 'Perkhidmatan selesai',
            },
            uploadCheckout: 'Muat naik fail, foto, atau video',
            visitNotes: 'Nota lawatan',
            workOrderResolution: 'Resolusi pesanan kerja',
            enterNotes: 'Masukkan sebarang nota di sini...',
            errors: {
              timedOut: 'Masa tamat, melebihi 30 saat. Sila cuba lagi.',
              closingSession: 'Ralat menutup sesi',
            },
          },
          success: {
            description:
              'Terima kasih kerana melawat {site}. | {site} masih mempunyai 1 pesanan kerja terbuka. | {site} masih mempunyai {count} pesanan kerja terbuka.',
            endVisit: 'Tamat lawatan',
            header: 'Anda telah berjaya daftar keluar',
            viewWorkOrders: 'Daftar masuk ke pesanan kerja lain',
          },
          verification: {
            code: {
              description:
                'Untuk daftar keluar, sila dapatkan kod 4 digit daripada pengurus tapak atau orang yang ditetapkan.',
              continue: 'Teruskan',
            },
            geo: {
              checkOut: 'Daftar keluar',
              continue: 'Teruskan',
            },
          },
        },
        detail: {
          assets: 'Aset',
          call: 'Panggil',
          checkOut: 'Daftar keluar',
          closed: 'Ditutup',
          details: 'Butiran',
          dueBy: 'Tarikh tamat tempoh',
          manageEngineers: 'Urus jurutera',
          notAvailable: 'Tidak tersedia',
          pointOfContact: 'Orang untuk dihubungi',
          siteAccessTimes: 'Waktu akses tapak',
          siteAccessInstructions: 'Arahan akses',
          siteAddress: 'Alamat tapak',
          siteNotes: 'Nota tapak',
          siteTelephone: 'Telefon tapak',
          siteLocation: 'Lokasi tapak',
          updates: 'Kemas kini',
          more: 'Lagi',
          mismatchErrorTitle: 'Ralat pesanan kerja',
          mismatchErrorMessage:
            'Pesanan kerja yang anda cuba akses tidak sepadan dengan yang anda sedang daftar masuk. Sila semak pesanan kerja anda dan cuba lagi.',
          siteDocuments: 'Dokumen tapak',
          validFrom: 'Sah dari',
          validUntil: 'Sah sehingga',
          documentName: 'Nama dokumen',
          documentType: 'Jenis dokumen',
          attachments: 'Fail pesanan kerja',
          download: 'Muat turun',
          workDetails: 'Butiran kerja',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Tambah jurutera pembantu',
            assistantEngineers: 'Jurutera pembantu',
            description: 'Untuk tujuan keselamatan, sila nyatakan nama setiap jurutera di tapak.',
            editMainEngineer: 'Edit jurutera utama',
            errors: {
              creatingEngineer: 'Ralat mencipta jurutera',
              creatingSession: 'Ralat mencipta sesi',
            },
            header: 'Jurutera di tapak',
            mainEngineer: 'Jurutera utama',
            newAssistantEngineer: 'Masukkan nama penuh mereka',
            next: 'Seterusnya',
            removeEngineer: 'Buang jurutera',
            selectExistingAssistantEngineer: 'Mula menaip nama mereka',
          },
          index: {
            description: 'Untuk tujuan keselamatan, sila nyatakan nama setiap jurutera di tapak.',
            errorCreatingEngineer: 'Ralat mencipta jurutera, sila cuba lagi.',
            header: 'Jurutera di tapak',
            hintMainEngineer: 'Masukkan nama penuh jurutera utama',
            newMainEngineer: 'Jurutera utama baharu',
            next: 'Seterusnya',
            selectExistingMainEngineer: 'Pilih jurutera utama sedia ada',
            yes: 'Ya',
            no: 'Tidak',
            mainEngineerLabel: 'Adakah anda jurutera utama?',
          },
        },
        index: {
          callUsOn: 'Hubungi kami di {phoneNumber}',
          description: 'Tidak jumpa apa yang anda cari?',
          dueBy: 'Tarikh tamat tempoh',
          header: 'Pilih pesanan kerja',
          notAvailable: 'Tidak tersedia',
          searchWorkOrders: 'Cari pesanan kerja...',
        },
        manageEngineers: {
          manageEngineers: 'Urus jurutera',
          notWorking: 'Pekerja tidak aktif',
          pause: 'Jeda',
          resume: 'Sambung',
          workingNow: 'Pekerja aktif',
          startTime: 'Masa mula',
          endTime: 'Masa tamat',
          duration: 'Tempoh',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Maklum balas',
            feedbackDescription:
              'Sila berikan maklum balas mengenai pesanan kerja untuk membantu kami meningkatkan perkhidmatan.',
            feedbackLabel: 'Maklum balas',
            filesLabel: 'Lampiran',
            submissionLabel: 'Hantar maklum balas',
          },
          hazards: {
            back: 'Kembali',
            hazards: 'Bahaya',
            next: 'Seterusnya',
            no: 'Tidak',
            noTasksForHazard: 'Tiada tugas untuk bahaya ini.',
            yes: 'Ya',
          },
          induction: {
            continue: 'Teruskan',
            induction: 'Induksi',
          },
          index: {
            checkIn: 'Daftar masuk',
            description: 'Sila lengkapkan penilaian risiko berikut untuk kerja yang dipilih.',
            fail: 'Gagal memproses semakan mula kerja.',
            haltMessage:
              'Risiko berpotensi dikesan. Sila hentikan kerja, semak garis panduan keselamatan, dan hubungi penyelia anda untuk arahan lanjut.',
            header: 'Semakan mula kerja',
            endVisit: 'Tamat lawatan',
            leaveFeedback: 'Tinggalkan maklum balas',
          },
          safeToProceed: {
            continue: 'Teruskan',
            safeToProceed: 'Selamat untuk diteruskan',
          },
        },
      },
    },
    index: {
      title: 'Selamat datang',
      description: 'Imbas kod QR di lokasi anda untuk bermula.',
    },
    login: {
      errorTitle: 'Ralat tidak dijangka',
      errorMessage: 'Ralat tidak dijangka berlaku. Sila cuba imbas kod QR sekali lagi.',
    },
    unauthenticated: {
      welcome: {
        title: 'Selamat datang ke {site}',
        description:
          'Sebelum kami dapat menunjukkan sebarang pesanan kerja, kami perlu mengesahkan butiran anda. Klik butang di bawah untuk meneruskan.',
        next: 'Teruskan',
      },
      index: {
        errorTitle: 'Ralat tidak dijangka',
        errorMessage: 'Ralat tidak dijangka berlaku. Sila cuba imbas kod QR sekali lagi.',
      },
      contractor: {
        title: 'Anda bekerja untuk siapa?',
        contractor: 'Kontraktor',
        contractorLabel: 'Mula menaip nama syarikat anda',
        contractorHint: 'Anda mesti memasukkan 3 aksara atau lebih untuk melihat hasil',
        defaultSelectPlaceholder: '--Sila pilih--',
        next: 'Seterusnya',
      },
      user: {
        title: 'Siapa anda?',
        cancel: 'Batal',
        createNewUserLabel: 'Nama saya tiada dalam senarai',
        existingUserLabel: 'Mula menaip nama anda',
        existingUserHint: 'Anda mesti memasukkan 3 aksara atau lebih untuk melihat hasil',
        newUserLabel: 'Masukkan nama penuh anda',
        next: 'Seterusnya',
        user: 'Pengguna',
      },
      verification: {
        methods: {
          add: {
            add: 'Tambah kaedah pengesahan',
            defaultSelectPlaceholder: '--Sila pilih--',
            emailLabel: 'E-mel',
            existingMethodWarning:
              'Anda sudah mempunyai permintaan tertunda untuk kaedah pengesahan ini yang menunggu kelulusan pentadbir. Menambah yang baharu akan menggantikannya.',
            method: 'Kaedah',
            methodLabel: 'Kaedah',
            mobileCountryHint: 'Sila pilih kod negara anda',
            mobileCountryLabel: 'Kod negara mudah alih',
            mobileHint: 'Sila masukkan nombor mudah alih anda',
            mobileLabel: 'Mudah alih',
            title: 'Tambah kaedah pengesahan',
          },
          confirm: {
            confirm: 'Sahkan',
            description: 'Sila sahkan kaedah pengesahan anda untuk meneruskan.',
            label: 'Masukkan kod anda',
            resend: 'Hantar semula',
            resendPrompt: 'Tidak terima kod?',
            title: 'Sahkan Kaedah Pengesahan',
          },
          confirmed: {
            description:
              'Anda akan dimaklumkan apabila kaedah pengesahan ini telah diluluskan oleh pentadbir anda, dan anda boleh mula menggunakannya untuk mengesahkan identiti anda.',
            forceApproval: 'Sehingga ia diluluskan, anda tidak dapat mengakses pesanan kerja.',
            nonForceApproval:
              'Sementara itu, anda boleh terus mengakses pesanan kerja dengan akses terhad.',
            nonForceApprovalButtonLabel: 'Teruskan dengan akses terhad',
            title: 'Menunggu kelulusan',
          },
          addNew: 'Tambah kaedah pengesahan baharu',
          description:
            'Kami perlu mengesahkan identiti anda untuk memberikan anda akses penuh kepada pesanan kerja.',
          email: 'E-mel',
          hint: 'Kami akan menghantar pautan ke kaedah pengesahan yang dipilih untuk memberikan anda akses penuh kepada pesanan kerja. Jika anda perlu menukar sebarang kaedah pengesahan sedia ada, sila hubungi pentadbir anda.',
          label: 'Pilih kaedah pengesahan',
          next: 'Seterusnya',
          pendingHint: 'Menunggu kelulusan daripada pentadbir anda',
          sms: 'SMS',
          title: 'Pengesahan',
        },
        optional: {
          hint: 'Mengesahkan butiran pengguna anda akan memberikan anda akses penuh kepada pesanan kerja',
          label: 'Adakah anda mahu mengesahkan butiran pengguna anda?',
          next: 'Seterusnya',
          no: 'Tidak',
          noHint:
            'Saya tidak mahu mengesahkan butiran pengguna saya dan teruskan dengan akses terhad kepada pesanan kerja',
          title: 'Pengesahan',
          yes: 'Ya',
          yesHint:
            'Saya mahu mengesahkan butiran pengguna saya dan dapatkan akses penuh kepada pesanan kerja',
        },
        sent: {
          description:
            'Pautan log masuk telah dihantar ke {identifier}. Sila klik pautan untuk melengkapkan log masuk anda.',
          title: 'Pautan log masuk dihantar',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Semalam',
      today: 'Hari ini',
      days: {
        monday: 'Isnin',
        tuesday: 'Selasa',
        wednesday: 'Rabu',
        thursday: 'Khamis',
        friday: 'Jumaat',
        saturday: 'Sabtu',
        sunday: 'Ahad',
      },
      months: {
        january: 'Januari',
        february: 'Februari',
        march: 'Mac',
        april: 'April',
        may: 'Mei',
        june: 'Jun',
        july: 'Julai',
        august: 'Ogos',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Disember',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Sesuatu telah berlaku',
      message: 'Sila cuba imbas kod QR sekali lagi.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Pengguna tidak diketahui',
      },
      none: 'Tiada',
      types: {
        stateTransition: 'Status ditukar',
        contractorAssigned: 'Kontraktor ditetapkan',
        engineerAssigned: 'Jurutera ditetapkan',
        serviceAssigned: 'Perkhidmatan ditetapkan',
        priorityChanged: 'Keutamaan ditukar',
        actionableDateChanged: 'Tarikh boleh diambil tindakan ditukar',
        dueDateChanged: 'Tarikh tamat ditukar',
        etaDateChanged: 'Tarikh jangkaan ketibaan ditukar',
        spendLimitApproved: 'Had perbelanjaan diluluskan',
        spendLimitCancelled: 'Permintaan had perbelanjaan dibatalkan',
        spendLimitRejected: 'Had perbelanjaan ditolak',
        spendLimitRequested: 'Permintaan had perbelanjaan',
        jobSheetUploaded: 'Lembaran kerja dimuat naik',
        slaAlertSent: 'Amaran SLA masa kehadiran dilanggar',
        issuedWorkPermit: 'Permit kerja dikeluarkan',
        requestForServiceSent: 'Permintaan perkhidmatan dihantar',
        comment: 'Komen ditambah',
        unknown: 'Peristiwa tidak diketahui',
      },
      labels: {
        actionableDate: 'Tarikh boleh diambil tindakan',
        comment: 'Komen',
        file: 'Fail',
        contractor: 'Kontraktor',
        dueDate: 'Tarikh tamat',
        etaDate: 'Tarikh jangkaan ketibaan',
        engineer: 'Jurutera',
        priority: 'Keutamaan',
        requestForService: 'Permintaan perkhidmatan',
        service: 'Perkhidmatan',
        spendLimit: 'Had perbelanjaan',
        status: 'Status',
        workPermit: 'Permit kerja',
      },
    },
  },
}
